import { Box, Icon, Typography } from '@mui/material'

import { React, useState } from 'react'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxButton from 'components/custom/AdxButton'

const LearnMoreModal = () => {
  const [modalState, setModalState] = useState(false)

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  return (
    <>
      <Typography
        onClick={handleOpen}
        variant="body2"
        sx={{
          cursor: 'pointer',

          textDecoration: 'underline',
          color: 'alternate.main',
        }}
      >
        Learn More
      </Typography>
      <AdxFormModal
        title="About Employee Details Template"
        subtitle=""
        icon={<Icon>error</Icon>}
        iconColor="info.main"
        open={modalState}
        onClose={handleClose}
        handleClose={handleClose}
        handleAction={() => alert('Action button pressed')}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="subtitle1">
            The template file will extract all employees data during the initial set up.
          </Typography>
          <Typography variant="subtitle1">
            You will need to fill up the details for each user to allow the policies to be seen by
            the user. The leave details extracted is a template to allow new information to be
            filled in.
          </Typography>
          <AdxButton fullWidth onClick={handleClose}>
            Back
          </AdxButton>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default LearnMoreModal
